import * as React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import "./styles.css";

class Optimization extends React.Component {

  constructor(props) {
    super(props);
    this.state = {value: 'aidm-discovery'};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    alert('You selected: ' + this.state.value);
    console.log(this.state.value)
    event.preventDefault();
  }

  render() {
    return (
      <div className = "App">
        <div>
        <div style={{marginTop:20}}></div>
          <Grid
              container
              direction="column"
              alignItems="center"
              >
              <FormControl onSubmit={() => this.state.value.name}>
              <FormLabel component="legend"></FormLabel>
              <RadioGroup
                  aria-label="optimization"
                  name="optimization"
                  value={this.state.value}
                  onChange={this.handleChange}
              >
                  <FormControlLabel id="aidm-discovery" name="aidm-discovery" value="aidm-discovery" control={<Radio />} label="AIDM Discovery" />
                  <FormControlLabel id="aidm-budget" name="aidm-budget" value="aidm-budget" control={<Radio />} label="AIDM Budget" />
                  <FormControlLabel id="dsp-optimized" name="dsp-optimized" value="dsp-optimized" control={<Radio />} label="DSP Optimized" />
              </RadioGroup>
              </FormControl>

              {console.log(this.state.value)}
          </Grid>
          <div style={{marginBottom:20}}></div>
        </div>
      </div>
    );
  }
}

export default Optimization;
